<ul class="nav flex-column">
    <li class="nav-item" *ngFor="let mn of menus">
        <a class="nav-link btn btn-info" href="javascript:void(0)" [class.text-right]="isArab"
            [class.active]="(mn.url !== null) && (currentUrl.toLowerCase().indexOf(mn.url.toLowerCase()) != -1)"
            [routerLink]="['/' + mn.url]" routerLinkActive="router-link-active" *ngIf="!iseirect(mn.url)"> {{mn.Title}}</a>
        <a class="nav-link btn btn-info" href="javascript:void(0)" [class.text-right]="isArab"
            *ngIf="(mn.url !== null && mn.url !== undefined) && iseirect(mn.url)" [href]="mn.url"> {{mn.Title}}</a>
    </li>
</ul>